import React from 'react';
import Modal from './Modal';

const StaffBio = ({ member, isOpen, setIsOpen }) => {
  if (!member) return null;

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="flex flex-col sm:flex-row items-center sm:items-start mb-6 text-center sm:text-left">
        <img 
          src={member.image} 
          alt={member.alt}
          className="w-28 h-28 sm:w-36 sm:h-36 rounded-full object-cover shadow-lg mb-4 sm:mb-0 sm:mr-6 border-4 border-gray-700 flex-shrink-0"
        />
        <div className="flex-grow">
          <h2 className="text-2xl sm:text-3xl font-bold text-sky-300">{member.name}</h2>
          <p className="text-lg sm:text-xl text-gray-400 mt-1">{member.role}</p>
        </div>
      </div>

      <div className="mb-6 text-left">
        <h4 className="text-md sm:text-lg font-semibold text-sky-400 mb-2">About:</h4>
        <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{member.bio || "More details coming soon."}</p>
      </div>

      {member.skills && member.skills.length > 0 && (
        <div className="text-left">
          <h4 className="text-md sm:text-lg font-semibold text-sky-400 mb-3">Key Skills:</h4>
          <div className="flex flex-wrap gap-2">
            {member.skills.map(skill => (
              <span 
                key={skill}
                className="bg-sky-600/40 text-sky-200 text-xs sm:text-sm px-3 py-1 rounded-full"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default StaffBio;